import User       from './../User'
import Definition from './../../entity/Definition'

export default new class DefinitionsGetter {

  constructor () {
    this._definitions = []
  }

  /**
   *
   * @param args
   * @param success
   * @param error
   * @return {Promise<any>}
   */
  getDataDefinition (args, success, error) {
    let initialized = this._initialized(args)

    if (initialized !== null) {
      return new Promise((resolve, reject) => {
        success(this._definitions[initialized].def)
        resolve()
      })
    }

    let innerSuccess = (response) => {
          let definition = new Definition(response)
          success(definition)
          this._definitions.push({ args: args, def: definition })
          this._promiseDefinitions = []
        },
        promise      = User.getEntityDefinitions(args, innerSuccess, error)

    return promise
  }

  /**
   *
   * @param args
   * @private
   */
  _initialized (args) {
    let index = null

    return null

    this._definitions.forEach((item, i) => {
      console.log("initialized", item, args)
      if (item.args.code === args.code
        && item.args.idtEntityStructureFrom === args.idtEntityStructureFrom) {
        index = i
        return true
      }
    })

    return index
  }

}
